var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "team-member",
    class: {
      more: _vm.moreOpened,
      animating: _vm.animating
    }
  }, [_c('div', {
    staticClass: "info-drawer"
  }, [_c('div', {
    staticClass: "info-content quotes",
    domProps: {
      "innerHTML": _vm._s(_vm.member.quote)
    }
  }), _c('div', {
    staticClass: "info-content bottom"
  }, [_c('ul', _vm._l(_vm.member.boxes, function (box) {
    return _c('li', {
      staticClass: "paragraph-1"
    }, [_vm._v(_vm._s(box.experience))]);
  }), 0)]), _c('div', {
    staticClass: "button-container back"
  }, [_c('seu-button', {
    attrs: {
      "label": _vm.moreOpened ? _vm.member.buttonLabelLess : _vm.member.buttonLabel
    },
    on: {
      "click": function ($event) {
        _vm.moreOpened ? _vm.closeMore() : _vm.openMore();
      }
    }
  })], 1)]), _c('div', {
    staticClass: "team-member-container"
  }, [_c('div', {
    staticClass: "main-content"
  }, [_c('div', {
    staticClass: "content-wrapper"
  }, [_c('img', {
    attrs: {
      "src": _vm.member.image,
      "alt": ""
    }
  })])]), _c('div', {
    staticClass: "main-content"
  }, [_c('div', {
    staticClass: "content-wrapper member-info-container"
  }, [_c('div', {
    staticClass: "member-name heading-3-bold"
  }, [_vm._v(_vm._s(_vm.member.fullName))]), _c('div', {
    staticClass: "info-wrapper"
  }, [_c('div', {
    staticClass: "caps-regular member-position",
    domProps: {
      "innerHTML": _vm._s(_vm.member.position)
    }
  }), _c('div', {
    staticClass: "divider"
  }), _c('div', [_c('a', {
    staticClass: "action-row",
    attrs: {
      "href": `mailto:${_vm.member.email}`
    }
  }, [_c('img', {
    staticClass: "member-icon",
    attrs: {
      "src": require("../assets/icons/mail-icon.svg"),
      "alt": ""
    }
  }), _c('div', [_vm._v(_vm._s(_vm.member.email))])]), _c('a', {
    staticClass: "action-row",
    attrs: {
      "href": `tel:${_vm.member.phone}`
    }
  }, [_c('img', {
    staticClass: "member-icon",
    attrs: {
      "src": require("../assets/icons/phone-icon-black.svg"),
      "alt": ""
    }
  }), _c('div', [_vm._v(_vm._s(_vm.member.phone))])]), _c('div', {
    staticClass: "socials-container action-row"
  }, [_vm.member.linkedin ? _c('a', {
    attrs: {
      "target": "_blank",
      "href": _vm.member.linkedin
    }
  }, [_c('img', {
    staticClass: "member-icon",
    attrs: {
      "src": require("../assets/icons/linkedin-icon.svg"),
      "alt": ""
    }
  }), _c('div', [_vm._v("LinkedIn")])]) : _vm._e(), _vm.member.website ? _c('a', {
    attrs: {
      "href": `http://www.${_vm.member.website}`,
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "member-icon",
    attrs: {
      "src": require("../assets/icons/world-icon.svg"),
      "alt": ""
    }
  }), _c('div', [_vm._v(_vm._s(_vm.member.website))])]) : _vm._e()])])])])]), _c('div', {
    staticClass: "button-container"
  }, [_c('seu-button', {
    attrs: {
      "label": _vm.moreOpened ? _vm.member.buttonLabelLess : _vm.member.buttonLabel
    },
    on: {
      "click": function ($event) {
        _vm.moreOpened ? _vm.closeMore() : _vm.openMore();
      }
    }
  })], 1)])]);

}
var staticRenderFns = []

export { render, staticRenderFns }